<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay" @click.self="$emit('close')">
      <div class="modal-window">
        <div class="modal-content">
          <section class="list-box white-box row">
            <h2 class="modal-title">新規ユーザー登録</h2>
            <form>
              <table class="register-table">
                <tr>
                  <th class="util-width-40">メールアドレス</th>
                  <td>
                    <input type="text" v-model="registerUserForm.email" name="email">
                      <div v-if="submitted && !$v.registerUserForm.email.required" class="text-error util-line-height-none"><small>メールアドレスを入力してください。</small></div>
                      <div v-if="submitted && $v.registerUserForm.email.required && !$v.registerUserForm.email.email" class="text-error util-line-height-none"><small>メールアドレスのフォーマットに誤りがあります。</small></div>
                  </td>
                </tr>
                <tr>
                  <th>氏名</th>
                  <td>
                    <input type="text" v-model="registerUserForm.name" name="name">
                    <div v-if="submitted && !$v.registerUserForm.name.required" class="text-error util-line-height-none"><small>お名前を入力してください。</small></div>
                  </td>
                </tr>
                <tr>
                  <th>性別</th>
                  <td>
                    <label><input type="radio" v-model="registerUserForm.gender" name="sex" value="0">男性</label>
                    <label><input type="radio" v-model="registerUserForm.gender" name="sex" value="1">女性</label>
                    <label><input type="radio" v-model="registerUserForm.gender" name="sex" value="2">無回答</label>
                    <div v-if="submitted && !$v.registerUserForm.gender.required" class="text-error util-line-height-none"><small>性別を選択してください。</small></div>
                  </td>
                </tr>
                <tr>
                  <th>部署名</th>
                  <td>
                    <input type="text" v-model="registerUserForm.department" name="department" placeholder="※ない場合は「なし」と入力してください">
                    <div v-if="submitted && !$v.registerUserForm.department.required" class="text-error util-line-height-none"><small>部署名を入力してください。</small></div>
                  </td>
                </tr>
                <tr>
                  <th>役職</th>
                  <td>
                    <input type="text" v-model="registerUserForm.position" name="position" placeholder="※ない場合は「なし」と入力してください">
                    <div v-if="submitted && !$v.registerUserForm.position.required" class="text-error util-line-height-none"><small>役職を入力してください。</small></div>
                  </td>
                </tr>
              </table>
              <label class="text-error util-line-height-none">{{ errorMessage }}</label>
              <div class="modal-btn">
                <span class="btn-gray2"><button @click.prevent="$emit('close')">キャンセル</button></span>
                <span class="btn-gray2"><button @click.prevent="registerBtnClick">登録する</button></span>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import httpResource from '../http/httpResource'
import store from '../store/index'
import { required, email } from 'vuelidate/lib/validators'
import Processing from '../util/processing'
import { parseApierror } from '../util/utils'
export default {
  mixins: [Processing],
  data () {
    return {
      registerUserForm: {
        email: null,
        name: null,
        gender: null,
        department: null,
        position: null
      },
      submitted: false,
      displayErrorMessage: false,
      errorMessage: ''
    }
  },
  validations: {
    registerUserForm: {
      email: {
        required,
        email
      },
      name: {
        required
      },
      gender: {
        required
      },
      department: {
        required
      },
      position: {
        required
      }
    }
  },
  methods: {
    async registerBtnClick () {
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      try {
        const response = await httpResource.post('/corporation/users', this.registerUserForm, {headers: {Authorization: `Bearer ${store.getters.getAuthData.token}`}})
        if (response.status === 200) {
          this.$emit('reloadData')
          this.$emit('close')
        }
      } catch (error) {
        const apierror = parseApierror(error)
        this.displayErrorMessage = true
        this.errorMessage = apierror.message
      }
      setTimeout(function () {
        // ボタンのロックを解除する
        this.endProcessing()
      }.bind(this), 2000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewRegistModal.vue